import { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { userServices } from "../../APIServices/userServices";
import Swal from "sweetalert2";

const UpdateProfileName = ({
  setActiveItem,
  getCurrectLoginUser,
  currentUserData,
}) => {
  const [fullName, setFullName] = useState("");
  const [loader, setLoader] = useState("");

  const updateProfile = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Profile Name?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.fullName = fullName;
        let data = await userServices.updateProfile(userData);
        if (data?.statusCode === 200) {
          getCurrectLoginUser();
        }
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    setFullName(currentUserData?.name || "");
  }, [currentUserData]);
  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3 hstack justify-content-between">
        <h5 className="fw-bold mb-1">Update Name</h5>
        <Button
          variant="outline-light"
          className="text-danger hstack gap-2 py-1 px-2 rounded-2"
          style={{ fontSize: 14 }}
          onClick={() => setActiveItem("")}
        >
          <FaXmark /> Cancel
        </Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 106px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-2 mb-3">
            <Card.Body>
              <Form.Group className="mb-2">
                <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                  Name
                </Form.Label>
                <Form.Control
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="interactive-input rounded-1"
                  style={{ fontSize: 12, padding: "6px 15px" }}
                  placeholder="Enter Name"
                />
              </Form.Group>
              <div className="hstack justify-content-end">
                <Button
                  disabled={!fullName || loader}
                  onClick={updateProfile}
                  variant="outline-primary"
                  style={{ fontSize: 13 }}
                  title="Update Name"
                  className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                >
                  <FaRegEdit /> Update Name
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default UpdateProfileName;
